<div class="related-violation-card">
  <div class="related-violation-card-title">
    <div class="related-violation-card-title-text" appLongTextTooltip>
      {{ title }}
    </div>
    <app-severity-label [severity]="input.severity" [smallSize]="true"></app-severity-label>
  </div>

  <div class="related-violation-card-status">
    <div>
      {{ 'inventoryResourcePage.relatedViolationCardStatusTitle' | labelsProvider }}
    </div>
    <app-status-label [statusLabel]="input.statusLabel"></app-status-label>
  </div>
  <app-card-fields [cardFields]="fields" [isToggleContentAllowed]="isToggleContentAllowed()" />

  <app-anchor-link navigation="" (clicked)="openViolation()">
    <div>{{ 'inventoryResourcePage.relatedViolationCardExploreViolationLink' | labelsProvider }}</div>
    <img src="assets/images/arrows/empty-arrow-right.svg" class="explore-violation-link__icon" />
  </app-anchor-link>
</div>
